export const productsData = {
  copos: {
    title: "JD Color Copos",
    icon: "🥤",
    items: [
      { id: 1, name: "Copo PP 330ml", image: "products_optimized/copoPP330.webp" },
      { id: 2, name: "Copo PP 440ml", image: "products_optimized/copoPP440.webp" },
      { id: 3, name: "Copo PP 550ml", image: "products_optimized/copoPP550.webp" },
      { id: 4, name: "Copo PP 770ml", image: "products_optimized/copoPP770.webp" },
      { id: 5, name: "Copo de Papel", image: "products_optimized/copoDePapel.webp" },
      { id: 6, name: "Copo de Isopor", image: "products_optimized/copoIsopor.webp" },
      { id: 7, name: "Copo Long Drink", image: "products_optimized/copoLongDrink.webp" },
      { id: 8, name: "Copo Eco", image: "products_optimized/copoEco.webp" },
      { id: 9, name: "Copo Twister", image: "products_optimized/copoTwister.webp" },
      { id: 136, name: "Copo com Borda Colorida", image: "products_optimized/copoBordaColorida.webp" }
    ]
  },
  potes: {
    title: "JD Potes",
    icon: "🍨",
    items: [
      { id: 11, name: "Pote PET 250ml", image: "products_optimized/potePet250.webp" },
      { id: 12, name: "Pote PET 500ml", image: "products_optimized/potePet500.webp" },
      { id: 13, name: "Pote de Papel", image: "products_optimized/potePapel.webp" },
      { id: 14, name: "Pote de Isopor", image: "products_optimized/poteIsopor.webp" }
    ]
  },
  sacolas: {
    title: "JD Sacolas",
    icon: "🛍️",
    items: [
      { id: 20, name: "Sacola de Papel", image: "products_optimized/sacolaPapel.webp" },
      { id: 33, name: "Sacola de Boca Palhaço", image: "products_optimized/sacolabocapalhaco.webp" },
      { id: 137, name: "Sacola Forte", image: "products_optimized/sacolaForte.webp" },
      { id: 138, name: "Sacola Verde 30x40 40x50 47x57",            image: "products_optimized/sacolaVerde.webp" },
      { id: 139, name: "Sacola Creme 30x40 38x48 47x57",            image: "products_optimized/sacolaCreme.webp" },
      { id: 140, name: "Sacola Branca 30x40 38x48 48x58",           image: "products_optimized/sacolaBranca.webp" },
      { id: 141, name: "Sacola Amarela 30x40 38x48",          image: "products_optimized/sacolaAmarela.webp" },
      { id: 142, name: "Sacola Azul 30x40 38x48",             image: "products_optimized/sacolaAzul.webp" },
      { id: 143, name: "Sacola Transparente 38x48",     image: "products_optimized/sacolaTransparente.webp" }
    ]
  },
  sacosPapel: {
    title: "JD Sacos de Papel",
    icon: "📄",
    items: [
      { id: 15, name: "Saco pra Lanche", image: "products_optimized/sacoLanche.webp" },
      { id: 16, name: "Saco de Delivery", image: "products_optimized/sacoDelivery.webp" },
      { id: 17, name: "Saco para Pães", image: "products_optimized/sacoPaes.webp" },
      { id: 202, name: "Sacola de Papel para Hamburguer com sua logo", image: "products_optimized/sacolaPapelHamburguer.webp" },
    ]
  },
  caixas: {
    title: "JD Caixas",
    icon: "📦",
    items: [
      { id: 18, name: "Caixa de Pizza", image: "products_optimized/caixaPizza.webp" },
      { id: 19, name: "Caixa de Salgado", image: "products_optimized/caixaSalgado.webp" },
      { id: 32, name: "Caixa PET para Bolo", image: "products_optimized/embalagempet.webp" },
      { id: 135, name: "Embalagem PET Personalizada", image: "products_optimized/embalagemPetPersonalizada.webp" },
      { id: 204, name: "Caixa para Hot Dog personalizada com sua logo", image: "products_optimized/caixaHotDog.webp" },
      { id: 205, name: "Caixa de Pizza Personalizada com sua logo", image: "products_optimized/caixaPizzaPersonalizada.webp" },
      { id: 206, name: "Embalagem Delivery Personalizada com sua logo", image: "products_optimized/sacolaDeliveryPersonalizada.webp" },
      { id: 207, name: "Caixa para Hambúrguer Personalizada com sua logo", image: "products_optimized/caixaHamburguerPersonalizada.webp" },
      { id: 208, name: "Caixa com Alça com sua logo", image: "products_optimized/caixaPizzaAlca.webp" },
    ]
  },
  isopor: {
    title: "JD Isopor",
    icon: "🧊",
    items: [
      { id: 24, name: "Marmita de Isopor", image: "products_optimized/marmitaIsopor.webp" },
      { id: 34, name: "Embalagem para Hambúrguer (Quadrada)", image: "products_optimized/hamburguerquadrada.webp" },
      { id: 35, name: "Embalagem para Hambúrguer (Redonda)", image: "products_optimized/hamburguerredonda.webp" },
      { id: 36, name: "Marmita de Isopor Personalizada", image: "products_optimized/marmitaPersonalizada.webp" },
      { id: 37, name: "Hamburgueira de Isopor Personalizada", image: "products_optimized/hamburgueiraPersonalizada.webp" }
    ]
  },
  outros: {
    title: "JD Produtos para Automação",
    icon: "📦",
    items: [
      { id: 22, name: "Etiqueta de Preço", image: "products_optimized/EtiquetaPreço.webp" },
      { id: 36, name: "Etiquetas de Balança 40x40 60x40 60x30", image: "products_optimized/rotulodebalanca.webp" },
      { id: 37, name: "Rótulos", image: "products_optimized/rotulo.webp" },
      { id: 38, name: "Lacres", image: "products_optimized/lacre.webp" }
    ]
  },
  limpeza: {
    title: "JD Limpeza e Higiene",
    icon: "🧹",
    items: [
      { id: 25, name: "Produtos de Limpeza", image: "products_optimized/produtosLimpeza.webp" },
      { id: 26, name: "Saco de Lixo", image: "products_optimized/sacoLixo.webp" },
      { id: 27, name: "Papel Higiênico", image: "products_optimized/papelHigienico.webp" },
      { id: 28, name: "Papel Toalha", image: "products_optimized/roloPapelToalha.webp" }
    ]
  },
   pack: {
    title: "JD Pack",
    icon: "🧴",
    items: [
      { id: 200, name: "Saco de Carvão 3kg e 5kg com sua logo", image: "products_optimized/sacoCarvao5kg.webp" },
      { id: 201, name: "Guardanapo sachê com sua logo", image: "products_optimized/estojoGuardanapo.webp" },
    ]
  },
  brindes: {
    title: "JD Brindes em Geral",
    icon: "🎁",
    items: [
      { id: 29, name: "Lixeira para Carro", image: "products_optimized/lixeiraCarro.webp", capacity: "" },
      { id: 30, name: "Canetas", image: "products_optimized/canetas.webp", capacity: "" },
      { id: 31, name: "Copo Stanley", image: "products_optimized/copoStanley.webp", capacity: "" },
      { id: 100, name: "Copo Ecológico", image: "products_optimized/copoEcologico.webp", capacity: "550 ml" },
      { id: 101, name: "Copo Ecológico Degradê", image: "products_optimized/copoEcologicoDegrade.webp", capacity: "" },
      { id: 102, name: "Copo Ecológico Tampa Bucks", image: "products_optimized/copoEcologicoTampaBucks.webp", capacity: "" },
      { id: 103, name: "Copo Ecológico Tampa e Canudo", image: "products_optimized/copoEcologicoTampaECanudo.webp", capacity: "550 ml" },
      { id: 104, name: "Copo Ecológico Tampa Flip", image: "products_optimized/copoEcologicoTampaFlip.webp", capacity: "550 ml" },
      { id: 105, name: "Copo Twistter com Tampa", image: "products_optimized/copoTwistterTampa.webp", capacity: "" },
      { id: 106, name: "Copo Twistter Tampa Flip", image: "products_optimized/copoTwisterTampaFlip.webp", capacity: "" },
      { id: 135, name: "Copo Twistter", image: "products_optimized/copoTwistter.webp", capacity: "" },
      { id: 107, name: "Copo Twistter Degradê", image: "products_optimized/copoTwistterDegradeTampaDegrade.webp", capacity: "" },
      { id: 108, name: "Copo Long Drink", image: "products_optimized/copoLongDrink.webp", capacity: "350 ml" },
      { id: 109, name: "Copo Long Drink Degradê", image: "products_optimized/copoLongDrinkDegrade.webp", capacity: "" },
      { id: 110, name: "Copo Long com Alça", image: "products_optimized/copoLongAlca.webp", capacity: "400 ml" },
      { id: 111, name: "Copo Mineirinho", image: "products_optimized/copoMineirinho.webp", capacity: "190 ml" },
      { id: 112, name: "Copo Mineirinho Shot", image: "products_optimized/copoMineirinhoShot.webp", capacity: "50 ml" },
      { id: 113, name: "Copo Tulipa", image: "products_optimized/copoTulipa.webp", capacity: "600 ml" },
      { id: 114, name: "Copo Whisky", image: "products_optimized/copoWhisky.webp", capacity: "330 ml" },
      { id: 115, name: "Copo Chantilly", image: "products_optimized/copoChantilly.webp", capacity: "" },
      { id: 136, name: "Copo Ecológico Label", image: "products_optimized/ecologicoLabel.webp", capacity: "" },
      { id: 137, name: "Copo Label Uv 360", image: "products_optimized/labelUv360.webp", capacity: "" },
      { id: 116, name: "Taça Espumante", image: "products_optimized/tacaEspumante.webp", capacity: "180 ml" },
      { id: 117, name: "Taça Espumante Degradê", image: "products_optimized/tacaEspumanteDegrade.webp", capacity: "" },
      { id: 118, name: "Taça Gin", image: "products_optimized/tacaGin.webp", capacity: "580 ml" },
      { id: 119, name: "Taça Gin Bicolor", image: "products_optimized/tacaGinBicolor.webp", capacity: "" },
      { id: 120, name: "Taça Gin Degradê", image: "products_optimized/tacaGinDegrade.webp", capacity: "" },
      { id: 121, name: "Taça Vinho", image: "products_optimized/tacaVinho.webp", capacity: "320 ml" },
      { id: 122, name: "Pint Ecológico", image: "products_optimized/pintEcologico.webp", capacity: "" },
      { id: 123, name: "Pint Ecológico Degradê", image: "products_optimized/pintEcologicoDegrade.webp", capacity: "" },
      { id: 124, name: "Caneca", image: "products_optimized/caneca.webp", capacity: "300 ml" },
      { id: 125, name: "Caneca Degradê", image: "products_optimized/canecaDegrade.webp", capacity: "" },
      { id: 126, name: "Acqua Bio", image: "products_optimized/acquaBio.webp", capacity: "480 ml" },
      { id: 127, name: "Acqua Bio Degradê", image: "products_optimized/acquaBioDegrade.webp", capacity: "" },
      { id: 128, name: "Acqua Bio Ecológico", image: "products_optimized/acquaBioEcologico.webp", capacity: "480 ml" },
      { id: 129, name: "Térmico UV 360°", image: "products_optimized/termicoUv360.webp", capacity: "" },
      { id: 130, name: "Coqueteleira", image: "products_optimized/coqueteleira.webp", capacity: "600 ml" },
      { id: 131, name: "Balde de Gelo", image: "products_optimized/baldeGelo.webp", capacity: "5 L" },
      { id: 132, name: "Balde de Pipoca Ecológico", image: "products_optimized/baldePipocaEco.webp", capacity: "1,8 L" },
      { id: 133, name: "Tampas Flip e Bucks", image: "products_optimized/tampasFlipeBucks.webp", capacity: "" },
      { id: 134, name: "Tirante e Suporte", image: "products_optimized/tiranteEsuporte.webp", capacity: "" },
      { id: 39, name: "Canecas Personalizadas", image: "products_optimized/canecasPersonalizadas.webp", capacity: "" }
    ],
    // Lista específica para a tabela de brindes
    tableItems: [
      { name: "Shot 50ml", capacity: "50 ml" },
      { name: "Copo Mineirinho 190ml", capacity: "190 ml" },
      { name: "Caneca 300ml", capacity: "300 ml" },
      { name: "Long Drink 350ml", capacity: "350 ml" },
      { name: "Caneca 430ml", capacity: "430 ml" },
      { name: "Long Drink com alça 400ml", capacity: "400 ml" },
      { name: "Long Drink com alça 420ml", capacity: "420 ml" },
      { name: "Copo Twister 480ml", capacity: "480 ml" },
      { name: "Tulipa de chopp 600ml PS", capacity: "600 ml" },
      { name: "Copo Twister com tampa e canudo 480ml", capacity: "480 ml" },
      { name: "Copo Twister com tampa chantilly 480ml", capacity: "480 ml" },
      { name: "Copo Twister com tampa Flip 480ml", capacity: "480 ml" },
      { name: "Copo Twister com tampa Starbucks 480ml", capacity: "480 ml" },
      { name: "Copo Twister 400ml", capacity: "400 ml" },
      { name: "Copo Twister com tampa e canudo 400ml", capacity: "400 ml" },
      { name: "Copo Twister com tampa Flip 400ml", capacity: "400 ml" },
      { name: "Copo Twister com tampa Starbucks 400ml", capacity: "400 ml" },
      { name: "Acqua Bio 480ml PS", capacity: "480 ml" },
      { name: "Tulipa de chopp 300ml", capacity: "300 ml" },
      { name: "Taça de vinho 320ml", capacity: "320 ml" },
      { name: "Copo de whisky 330ml", capacity: "330 ml" },
      { name: "Taça de Gin premium 580ml", capacity: "580 ml" },
      { name: "Mini Taça de Gin 450ml", capacity: "450 ml" },
      { name: "Taças espumante 180ml", capacity: "180 ml" },
      { name: "Balde 5 litros", capacity: "5 L" },
      { name: "Balde Pipoca PS 1,8 litros", capacity: "1,8 L" },
      { name: "Copo Ecológico 550ml", capacity: "550 ml" },
      { name: "Copo Ecológico tampa e canudo 550ml", capacity: "550 ml" },
      { name: "Copo Ecológico tampa Starbucks 550ml", capacity: "550 ml" },
      { name: "Copo Ecológico tampa chantilly 550ml", capacity: "550 ml" },
      { name: "Copo Ecológico tampa Flip 550ml", capacity: "550 ml" },
      { name: "Copo Ecológico 440ml", capacity: "440 ml" },
      { name: "Copo Ecológico tampa Flip 400ml", capacity: "400 ml" },
      { name: "Copo Ecológico tampa Starbucks 400ml", capacity: "400 ml" },
      { name: "Tulipa de chopp 600ml PP", capacity: "600 ml" },
      { name: "Coqueteleira 600ml", capacity: "600 ml" },
      { name: "Balde de pipoca 1,8 litros", capacity: "1,8 L" },
      { name: "Acqua Bio Ecológica 480ml", capacity: "480 ml" },
      { name: "Tampa e canudo Twister 550ml", capacity: "550 ml" },
      { name: "Tampa Flip 550ml", capacity: "550 ml" },
      { name: "Tampa Starbucks 550ml", capacity: "550 ml" },
      { name: "Tampa e canudo chantilly", capacity: "" },
      { name: "Tampa Flip 400ml", capacity: "400 ml" },
      { name: "Papel transfer", capacity: "" },
      { name: "Borda metalizada", capacity: "" },
      { name: "Borracha para tirante", capacity: "" },
      { name: "Tirante", capacity: "" },
      { name: "Borracha para tirante + tirante", capacity: "" }
    ]
  }
};